import { render, staticRenderFns } from "./ConfirmationSlip.vue?vue&type=template&id=47fc9f25&scoped=true&"
import script from "./ConfirmationSlip.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSlip.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSlip.vue?vue&type=style&index=0&id=47fc9f25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc9f25",
  null
  
)

export default component.exports